export default "__VITE_ASSET__BsvEXw6I__"